import React from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from "react-bootstrap/Card";

const optionPanelStyle = {
    position: "absolute",
    top: "296px",
    margin: "1em",
    zIndex: 100,
    width:"350px",
}

const QueryOptionForm = ({options, setOptions, handleSubmit, handleReset, ifShowExportButton}) => {
    const handleSelectOnChange = (e) => {
        let selectionId = e.target.id;
        let selectedValue = e.currentTarget.value;
        let newOptions = options.map((val, idx) => (idx.toString() === selectionId ? selectedValue : val));
        setOptions(newOptions);
    }

    return (
        <Card style={optionPanelStyle}>
            <Card.Body>
                <Card.Title>Abfrageoptionen</Card.Title>
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="0">Wählen Sie hier den gewünschten Bezugseinheitentyp zur Aggregation und
                            Darstellung von Pendelströmen aus: </Form.Label>
                        <Form.Select
                            id="0"
                            value={options[0]}
                            onChange={handleSelectOnChange}>
                            <option value="gemeinde">Gemeinden</option>
                            <option value="1000m">1.000m Rasterzellen</option>
                            <option value="500m">500m Rasterzellen</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="1">Pendlertyp: </Form.Label>
                        <Form.Select
                            id="1"
                            value={options[1]}
                            onChange={handleSelectOnChange}>
                            <option value="worker">Erwerbspendler</option>
                            <option value="student">Schülerpendler</option>
                        </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label htmlFor="2">Pendelrichtung: </Form.Label>
                        <Form.Select
                            id="2"
                            value={options[2]}
                            onChange={handleSelectOnChange}>
                            <option value="in">Einpendler</option>
                            <option value="out">Auspendler</option>
                        </Form.Select>
                    </Form.Group>
                    <Button variant="primary" type="submit" className="me-2">
                        Suchen
                    </Button>
                    <Button variant="danger" type="reset" className="me-2">Löschen</Button>
                    { ifShowExportButton &&
                        <Button variant="secondary" onClick={window.print} >Exportieren</Button>
                    }
                </Form>
            </Card.Body>
        </Card>
    )
}

export default QueryOptionForm;